import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';

const NoProductsFound = () => {
  return (
    <div className="NoProductsFound">
      <FormattedMessage {...globalTranslations.noProductsFoundSentence} />
    </div>
  );
}

export default NoProductsFound;
